import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import api from '@/utils/fetch'


export default /*#__PURE__*/_defineComponent({
  __name: 'JsonMedia',
  props: {
    src: null
  },
  setup(__props: any) {

const props = __props as {
  src?: string
}


const items = ref<{ key: string; value: string }[]>([])

onMounted(async () => {
  if (props.src) {
    const { data } = await api.get(props.src)

    items.value = Object.entries(data).map(([key, value]) => ({
      key,
      value: JSON.stringify(value),
    }))
  }
})

return { __sfc: true,props, items }
}

})